import i18n from 'i18n-js';

import {
  UsePriorityTooltipConfigProps,
  UsePriorityTooltipConfigResult,
  PriorityConfig,
  DaysConfig,
} from '../types';

const usePriorityTooltipConfig = ({
  isPriorityIncreased,
  isPriorityDecreased,
  priorityDisplayText,
  daysDifference,
  isBehind,
  isAhead,
}: UsePriorityTooltipConfigProps): UsePriorityTooltipConfigResult => {
  let priorityConfig: PriorityConfig | null = null;

  if (isPriorityIncreased) {
    priorityConfig = {
      title: i18n.t('Priority Increase'),
      description: i18n.t(
        'This job is moved up in the scheduling queue by treating it as if it was scheduled {{time}} earlier. This helps it start sooner. Drag and drop the tile to change priority',
        { time: priorityDisplayText }
      ),
      resetButtonText: i18n.t('Reset Priority Increase'),
      arrowRotation: '0deg',
      color: 'Chart/Light/Warning',
    };
  } else if (isPriorityDecreased) {
    priorityConfig = {
      title: i18n.t('Priority Decrease'),
      description: i18n.t(
        'This job is moved down in the scheduling queue by treating it as if it was scheduled {{time}} later. This allows other jobs to start sooner. Drag and drop the tile to change priority.',
        { time: priorityDisplayText }
      ),
      resetButtonText: i18n.t('Reset Priority Decrease'),
      arrowRotation: '180deg',
      color: 'System/Light/Blue',
    };
  }

  let daysConfig: DaysConfig | null = null;

  if (daysDifference !== null) {
    const absDays = Math.abs(daysDifference);

    if (isBehind) {
      daysConfig = {
        label: i18n.t('Days Behind'),
        explanation: i18n.t('This job will start {{days}} days later than scheduled.', { days: absDays }),
        color: 'Chart/Light/Warning',
      };
    } else if (isAhead) {
      daysConfig = {
        label: i18n.t('Days Ahead'),
        explanation: i18n.t('This job is expected to start {{days}} days earlier than scheduled.', { days: absDays }),
        color: 'System/Light/Blue',
      };
    } else {
      daysConfig = {
        label: i18n.t('On Schedule'),
        explanation: '',
        color: 'System/Light/Blue',
      };
    }
  }

  return { priorityConfig, daysConfig };
};

export default usePriorityTooltipConfig;
